import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // Small timeout to ensure DOM layout has settled after route change
    setTimeout(() => {
      const mainEl = document.getElementById('main-scroll-container');
      if (mainEl) {
        mainEl.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        // Fallback for browsers that don't support 'instant' or if scrollTo acts weird
        mainEl.scrollTop = 0;
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        window.document.documentElement.scrollTop = 0;
      }
    }, 10);
  }, [pathname])

  return null
}
